import {useEffect, useRef, useState} from "react";
import {exportPdf} from "../../../shared/utils/exportPdf";
import {PharmacyModel} from "../../../models/Pharmacy.model";
import {useAppDispatch} from "../../../app/hooks";
import http from "../../../shared/utils/http";
import {addErrorMessage, addSuccessMessage} from "../../../core/errors/errorSlice";
import {HourModel} from "../models/Hour.model";

export default function useActionsCalendar(hours: HourModel[], pharmacy: PharmacyModel | undefined, selectedRange: any, calendarCall: (start: Date, end: Date) => void) {
    const dispatch = useAppDispatch();
    const [printView, setPrintView] = useState<boolean>(false)
    const [saveModelModal, setSaveModelModal] = useState<any | undefined>(undefined);
    const [loadModelModal, setLoadModelModal] = useState<any | undefined>(undefined);
    const loadModel = ({model}: any) => {
        const idModel = model
        http.get(`pharmacies/${pharmacy?.idDocument}/model/${idModel}/${selectedRange.start.getFullYear()}/${selectedRange.start.getMonth()}/${selectedRange.start.getDate()}`).then(res => {
            setLoadModelModal(undefined)
            dispatch(addSuccessMessage({title: 'Modello caricato con successo!'}))
        }, err => {
            dispatch(addErrorMessage({title: 'Errore nel caricamento del modello, riprova più tardi, grazie.'}))
        })
    }
    const saveModel = ({nameModel}: any) => {
        const list = hours.map(ele => {
            const date = new Date(ele.date);
            return {
                dayNum: date.getDay(),
                list: ele.list,
                idEmployee: ele.idEmployee
            }
        })
        http.post(`pharmacies/${pharmacy?.idDocument}/model`, {
            list,
            name: nameModel
        }).then(res => {
            setSaveModelModal(undefined)
            dispatch(addSuccessMessage({title: 'Modello salvato con successo!'}))
        }, err => {
            dispatch(addErrorMessage({title: 'Errore nel salvataggio del modello, riprova più tardi, grazie.'}))
        })
    }

    const freezeAction = () => {
        if (selectedRange?.start && pharmacy) {
            const dateEnd = new Date(selectedRange.end);
            dateEnd.setMinutes(dateEnd.getMinutes() - 1);
            http.post(`pharmacies/${pharmacy.idDocument}/save`, {
                startYear: selectedRange.start.getFullYear(),
                startMonth: selectedRange.start.getMonth(),
                startDay: selectedRange.start.getDate(),
                endYear: selectedRange.end.getFullYear(),
                endMonth: selectedRange.end.getMonth(),
                endDay: selectedRange.end.getDate(),
            }).then(res => {
                calendarCall(selectedRange.start, selectedRange.end)
            }, err => {
                //TODO Luca gestione errore
            })
        }
    }
    const resetAction = () => {
        if (selectedRange?.start && pharmacy) {
            const dateEnd = new Date(selectedRange.end);
            dateEnd.setMinutes(dateEnd.getMinutes() - 1);
            http.post(`pharmacies/${pharmacy.idDocument}/reset`, {
                startYear: selectedRange.start.getFullYear(),
                startMonth: selectedRange.start.getMonth(),
                startDay: selectedRange.start.getDate(),
                endYear: selectedRange.end.getFullYear(),
                endMonth: selectedRange.end.getMonth(),
                endDay: selectedRange.end.getDate(),
            }).then(res => {
                calendarCall(selectedRange.start, selectedRange.end)
            }, err => {
                //TODO Luca gestione errore
                debugger
            })
        }
    }
    const clickHandler = (action: string) => {
        const actions: {[key: string]: () => void} = {
            load: () => setLoadModelModal(true),
            save: () => setSaveModelModal(true),
            freeze: () => freezeAction(),
            print: () => setPrintView(true),
            reset: () => resetAction()
        }
        actions[action] && actions[action]()
    }
    const pdfRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (printView) {
            exportPdf(`${pharmacy?.name}`, pdfRef, () => {
                window.close()
                setPrintView(false)
            })
        }
    }, [printView]);
    return {
        printView,
        clickHandler,
        saveModelModal,
        loadModelModal,
        loadModel,
        saveModel,
        pdfRef,
        setLoadModelModal,
        setSaveModelModal
    };
}
